export var FileType;
(function (FileType) {
    FileType["Audio"] = "Audio";
    FileType["Designer"] = "Designer";
    FileType["Excel"] = "Excel";
    FileType["Fluid"] = "Fluid";
    FileType["FluidActivityBlueprint"] = "FluidActivityBlueprint";
    FileType["Forms"] = "Forms";
    FileType["FormsQuiz"] = "FormsQuiz";
    FileType["Image"] = "Image";
    FileType["List"] = "List";
    FileType["Media"] = "Media";
    FileType["MeetingNotes"] = "MeetingNotes";
    FileType["MeetingObject"] = "MeetingObject";
    FileType["MindMeister"] = "MindMeister";
    FileType["Monday"] = "Monday";
    FileType["MyAnalytics"] = "MyAnalytics";
    FileType["NewsArticle"] = "NewsArticle";
    FileType["None"] = "None";
    FileType["OneDrive"] = "OneDrive";
    FileType["OneNote"] = "OneNote";
    FileType["OneNoteClassNoteBook"] = "OneNoteClassNoteBook";
    FileType["OneNotePage"] = "OneNotePage";
    FileType["Outlook"] = "Outlook";
    FileType["Pdf"] = "Pdf";
    FileType["Photos"] = "Photos";
    FileType["Platform"] = "Platform";
    FileType["PlayList"] = "PlayList";
    FileType["PlayLists"] = "PlayLists";
    FileType["Portfolio"] = "Portfolio";
    FileType["PowerBI"] = "PowerBI";
    FileType["PowerPoint"] = "PowerPoint";
    FileType["Project"] = "Project";
    FileType["ProjectOperations"] = "ProjectOperations";
    FileType["ScreenRecording"] = "ScreenRecording";
    FileType["SharePoint"] = "SharePoint";
    FileType["Spaces"] = "Spaces";
    FileType["Stream"] = "Stream";
    FileType["StreamsVideo"] = "StreamsVideo";
    FileType["Sway"] = "Sway";
    FileType["Text"] = "Text";
    FileType["ThirdParty"] = "ThirdParty";
    FileType["Todo"] = "Todo";
    FileType["Trello"] = "Trello";
    FileType["Unknown"] = "Unknown";
    FileType["UpcomingMeeting"] = "UpcomingMeeting";
    FileType["Video"] = "Video";
    FileType["Visio"] = "Visio";
    // Below are template types and not actual file types.
    FileType["VisioBusinessWac"] = "VisioBusinessWac";
    FileType["VisioFlowChartWac"] = "VisioFlowChartWac";
    FileType["VisioGeneralWac"] = "VisioGeneralWac";
    FileType["VisioNetworkWac"] = "VisioNetworkWac";
    FileType["VisioSoftwareWac"] = "VisioSoftwareWac";
    FileType["VisioStartWac"] = "VisioStartWac";
    FileType["Whiteboard"] = "Whiteboard";
    FileType["Word"] = "Word";
    FileType["Yammer"] = "Yammer";
})(FileType || (FileType = {}));
//# sourceMappingURL=FileType.js.map